## 교육

#### 청강문화산업대학교 컴퓨터게임전공(3년) (2012.03 ~ 2016.02)
